"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobContactPerson = exports.QuoteTargetEnum = void 0;
const data_ui_1 = require("../data-ui");
const typeorm_1 = require("typeorm");
const contact_profile_enum_1 = require("./contact-profile-enum");
const job_1 = require("./job");
var QuoteTargetEnum;
(function (QuoteTargetEnum) {
    QuoteTargetEnum["CUSTOMER"] = "customer";
    QuoteTargetEnum["CONTACT_PERSON"] = "contact_person";
    QuoteTargetEnum["ALL"] = "all";
})(QuoteTargetEnum = exports.QuoteTargetEnum || (exports.QuoteTargetEnum = {}));
let JobContactPerson = class JobContactPerson {
};
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", String)
], JobContactPerson.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        name: 'first_name',
        length: 255,
    }),
    __metadata("design:type", String)
], JobContactPerson.prototype, "firstName", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        name: 'last_name',
        length: 255,
    }),
    __metadata("design:type", String)
], JobContactPerson.prototype, "lastName", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        name: 'email',
        length: 255,
    }),
    __metadata("design:type", String)
], JobContactPerson.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'bool',
        name: 'use_for_email',
        default: false,
    }),
    __metadata("design:type", Boolean)
], JobContactPerson.prototype, "useForEmail", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        nullable: true,
        name: 'phone',
        length: 255,
    }),
    __metadata("design:type", String)
], JobContactPerson.prototype, "phone", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        nullable: false,
        enum: QuoteTargetEnum,
        name: 'quote_target',
        default: QuoteTargetEnum.CUSTOMER,
    }),
    __metadata("design:type", String)
], JobContactPerson.prototype, "quoteTarget", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => job_1.Job, (job) => job.jobContactPerson),
    (0, typeorm_1.JoinColumn)({ name: 'job_api_id', referencedColumnName: 'apiId' }),
    __metadata("design:type", Array)
], JobContactPerson.prototype, "jobs", void 0);
JobContactPerson = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    data_ui_1.DataUi.Name({
        name: 'Job Contact Person',
        nameProperties: ['firstName', 'lastName'],
    }),
    (0, typeorm_1.Entity)()
], JobContactPerson);
exports.JobContactPerson = JobContactPerson;
//# sourceMappingURL=job-contact-person.js.map